
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(3497|4568|8165)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
